import { render, staticRenderFns } from "./Sfzyc.vue?vue&type=template&id=3c52993e&scoped=true"
import script from "./Sfzyc.vue?vue&type=script&lang=js"
export * from "./Sfzyc.vue?vue&type=script&lang=js"
import style0 from "./Sfzyc.vue?vue&type=style&index=0&id=3c52993e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52993e",
  null
  
)

export default component.exports